module.exports = __webpack_public_path__ + "static/media/thomas_logo.00c84aeb.svg";